import type { IEventChannel } from "../model/Models";

export type ServiceAvailability = {
    dayOfWeek: "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY" | "WEEK" | "WEEKDAYS";
    startTime: number;
    endTime: number;
}

export default class ScheduleAvailabilityManager {
	private serviceAvailabilityMapping = new Map<string, ServiceAvailability[]>();
	private readonly scheduleId: number;
	private readonly eventChannel: IEventChannel;

	constructor(scheduleId: number) {
		this.scheduleId = scheduleId;
		this.eventChannel = es.util.createEventChannel({
			onAvailabilityChanged: 1
		}, "esApp.ScheduleAvailabilityManager");

		this.loadAvailabilityIntoMap();
		this.bindEvents();
	}

	public getAvailability(serviceId: string) {
		return this.serviceAvailabilityMapping.get(serviceId);
	}

	public getEventChannel() {
		return this.eventChannel;
	}

	private bindEvents() {
		es.api.getEventChannel().addListener("onUpdateScheduleServices", () => this.loadAvailabilityIntoMap());
		es.api.getEventChannel().addListener("onUpdateLayerMetaAvailabilities", () => this.loadAvailabilityIntoMap());
		es.api.getEventChannel().addListener("onEditFeatures", () => this.loadAvailabilityIntoMap());
		es.api.getEventChannel().addListener("onRemoveLayerMetaAvailabilities", () => this.loadAvailabilityIntoMap());
	}

	private async loadAvailabilityIntoMap() {
		const availabilityByService = await es.api.schedule.getServicesAvailability(this.scheduleId);
		this.serviceAvailabilityMapping = new Map(Object.entries(availabilityByService));
		this.eventChannel.fireEvent("onAvailabilityChanged", this);
	}
}